<template>
  <div>
    <div
      class="h5 text-morado-claro pt-1 px-2 font-weight-bold text-center text-lg-left gilmer text-uppercase"
    >
      Selecciona región, comuna y curso
    </div>
    <b-row class="bg-morado-claro pt-4 pb-1 mx-0 px-3">
      <!-- Seleccionar Región -->
      <b-col cols="12" lg class="text-morado-claro">
        <b-row class="form-group px-0 px-lg-2">
          <label
            for="select-region"
            class="mb-1 col-5 col-lg-12 px-0 mt-2 mt-lg-0 font-weight-bold h6"
            >Región</label
          >
          <b-form-select
            class="col-7 col-lg-12 btn-azul-outline font-weight-bold"
            id="select-region"
            data-testid="select-region"
            v-model="regionSeleccionada"
          >
            <option disabled value="null">- Escoge una región -</option>
            <option
              v-for="r in regiones"
              :key="r.idRegion"
              :value="r.idRegion"
              >{{ limpiarNombreRegion(r.nombreRegion) }}</option
            >
          </b-form-select>
        </b-row>
      </b-col>
      <!-- Seleccionar Región fin -->

      <!-- Seleccionar Comuna -->
      <b-col cols="12" lg class="text-morado-claro">
        <b-row class="form-group px-0 px-lg-2">
          <label
            for="select-comuna"
            class="mb-1 col-5 col-lg-12 px-0 mt-2 mt-lg-0 font-weight-bold h6"
            >Comuna</label
          >
          <b-form-select
            class="col-7 col-lg-12 btn-azul-outline font-weight-bold"
            id="select-comuna"
            data-testid="select-comuna"
            v-model="comunaSeleccionada"
          >
            <option disabled value="null">- Escoge una comuna -</option>
            <option
              v-for="c in optionsComunas"
              :key="c.idComuna"
              :value="{ nombreComuna: c.nombreComuna, idComuna: c.idComuna }"
              >{{ c.nombreComuna }}</option
            >
          </b-form-select>
        </b-row>
      </b-col>
      <!-- Seleccionar Comuna fin -->

      <!-- Seleccionar Nivel -->
      <b-col cols="12" lg class="text-morado-claro mb-2">
        <b-row class="form-group px-0 px-lg-2 mb-0">
          <label
            for="select-nivel"
            class="mb-1 col-5 col-lg-12 px-0 font-weight-bold h6 pr-2 pr-lg-0"
            >Nivel al que postula</label
          >
          <b-form-select
            class="col-7 col-lg-12 btn-azul-outline font-weight-bold"
            id="select-nivel"
            data-testid="select-nivel"
            v-model="nivelSeleccionado"
            :disabled="!comunaSeleccionada"
          >
            <option disabled value="null">- Escoge un nivel -</option>
            <option v-for="n in niveles" :key="n.valor" :value="n.valor">{{
              n.texto
            }}</option>
          </b-form-select>
        </b-row>
      </b-col>
      <!-- Seleccionar Nivel fin -->

      <!-- Buscar por nombre de establecimiento -->
      <b-col cols="12" lg class="text-morado-claro mb-2 alto ">
        <b-row class="form-group px-0 px-lg-2 mb-0">
          <label
            for="busqueda-nombre"
            class="mb-1 col-5 col-lg-12 px-0 font-weight-bold h6 pr-2 col-lg d-none d-lg-block pr-lg-0"
            >Establecimiento</label
          >
          <AutoCompletado
            :disable="comunaSeleccionada ? false : true"
            filterby="nombre"
            :shouldReset="false"
            @selected="establecimientoSeleccionado"
            title="Busqueda por nombre"
          />
        </b-row>
      </b-col>
      <!-- Buscar por nombre de establecimiento fin -->

      <!-- Más filtros -->
      <b-col cols="auto" class="text-center px-2 d-none d-lg-block">
        <span
          class="h6 align-middle text-morado-claro font-weight-bold d-block mb-1"
          >Filtros</span
        >
        <b-button
          variant="outline"
          id="boton-abrir-filtros-desktop"
          data-testid="boton-abrir-filtros-desktop"
          class="text-morado-claro border border-azul-medio2 bg-white btn"
          type="button"
          @click="botonFiltrosDesktop"
        >
          <FontAwesomeIcon icon="sliders-h"></FontAwesomeIcon>
        </b-button>
      </b-col>
      <!-- Más filtros fin -->
    </b-row>
  </div>
</template>

<script>
import ApiRegiones from "@/services/ApiRegiones";
import ApiEstablecimiento from "@/services/ApiEstablecimientos";
import Niveles from "@/utils/Niveles";
import AutoCompletado from "@/components/generales/Autocompletado";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faSearch, faSlidersH } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { mapGetters } from "vuex";
import VueGtag from "vue-gtag";
library.add(faSearch, faSlidersH);
export default {
  components: {
    FontAwesomeIcon,
    AutoCompletado
  },
  data() {
    return {
      fetch: false,
      regiones: [],
      niveles: [],
      filtro: "",
      regionSeleccionada: null,
      comunaSeleccionada: null,
      nivelSeleccionado: null,
      establecimientos: []
    };
  },
  mounted() {
    if (this.$store.state.region || this.$store.state.region > -1) {
      this.regionSeleccionada = this.$store.state.region;
      if (this.$store.state.comuna) {
        this.comunaSeleccionada = this.$store.state.comuna;
      }
    }
    if (this.$store.state.nivel) {
      this.nivelSeleccionado = this.$store.state.nivel;
    }
    this.fetch = true;
  },
  watch: {
    //limpia campo comunaSeleccionada al elegir una region
    regionSeleccionada: function(newValm, prevVal) {
      if (this.fetch) {
        if (prevVal) {
          this.comunaSeleccionada = null;
        }
        if (newValm || newValm > -1) {
          this.$gtag.event("modificar-region", {
            event_category: "busqueda",
            event_label: "region-" + newValm,
            value: ""
          });
          this.$emit("cambiarRegion", newValm);
        }
      }
    },
    //ejecuta una busqueda al seleccionarse una comuna
    comunaSeleccionada: function(val) {
      if (this.fetch) {
        if (val) {
          this.$gtag.event("modificar-comuna", {
            event_category: "busqueda",
            event_label: "comuna-" + val.nombreComuna,
            value: ""
          });
          this.$emit("cambiarComuna", val);
        }
      }
    },
    //cambia el valor del nivel seleccionado
    nivelSeleccionado: function(val) {
      if (this.fetch) {
        if (val || val == "") {
          this.$gtag.event("modificar-nivel", {
            event_category: "busqueda",
            event_label: "nivel-" + val,
            value: ""
          });
          this.$emit("cambiarNivel", val);
        }
      }
    }
  },
  created() {
    this.regiones = this.getDatosRegionesComuna();
    this.niveles = this.getDatosNiveles();
  },
  computed: {
    ...mapGetters(["getFiltros"]),
    //contiene arreglo de comunas a mostrar en el selector de comunas
    optionsComunas() {
      if (this.regionSeleccionada !== null) {
        //Elimina Comuna Antártica de la region
        let comunasRes = this.regiones[this.regionSeleccionada - 1].comunas;
        comunasRes.forEach(comuna => {
          if (comuna.nombreComuna === "ANTÁRTICA") {
            let indexCom = comunasRes.indexOf(comuna);
            comunasRes.splice(indexCom, 1);
          }
        });
        //Retorn arreglo ordenado
        return comunasRes.sort(function(a, b) {
          if (a.nombreComuna > b.nombreComuna) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        return [];
      }
    }
  },
  methods: {
    //emite evento para desplegar vista de filtros
    botonFiltrosDesktop: function() {
      this.$emit("toggleFiltrosDesktop");
    },
    //obtiene datos de regiones y comunas
    getDatosRegionesComuna: function() {
      return ApiRegiones.getRegionesYComunas();
    },
    //obtiene datos de regiones y comunas
    getDatosNiveles: function() {
      return Niveles.getNiveles();
    },
    //remueve "de" y "del" del principio de las regiones
    limpiarNombreRegion: function(region) {
      return region.replace(/(DEL |DE )/, "");
    },
    //api recibe con guion bajo y no espacio
    quitarEspacioNombreComuna: function(comuna) {
      return comuna.replace(/ /g, "_");
    },
    //traduce el index de la region seleccionada en su idRegion correspondiente
    traducirIndexRegion: function(index) {
      return this.regiones[index].idRegion;
    },
    establecimientoSeleccionado: function(establecimiento) {
      this.$router.push({
        name: "FichaEstablecimiento",
        params: { rbd: establecimiento.rbd }
      });
    }
  }
};
</script>

<style scoped>
@media (max-width: 990px) {
  .alto {
    min-height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/busqueda/FormBusqueda.vue